import { render, staticRenderFns } from "./SampleLicense.vue?vue&type=template&id=450a8f56&"
import script from "./SampleLicense.vue?vue&type=script&lang=js&"
export * from "./SampleLicense.vue?vue&type=script&lang=js&"
import style0 from "./SampleLicense.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports